import Config from '@/config'

export default {
  getApiUrlJoinPresentation() {
    return Config.api.joinPresentation
  },
}
